// features/articles/api.ts
import type { ArticleResponse, ArticleCategory } from './types'
import { getApiBase } from '../projects/api'

/**
 * Fetch articles từ backend API
 * @param category - Loại bài viết ('cam-nang' hoặc 'phong-thuy')
 * @param pages - Số trang scrape
 */
export const fetchArticlesByCategory = async (
  category: ArticleCategory,
  pages: number = 5
): Promise<ArticleResponse> => {
  try {
    const url = `${getApiBase()}/api/articles/${category}?pages=${pages}`

    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal: AbortSignal.timeout(30_000), // 30s timeout
    })

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`)
    }

    const data: ArticleResponse = await response.json()
    return data
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Không thể kết nối đến API'
    return {
      success: false,
      data: [],
      count: 0,
      pagesFetched: 0,
      message,
    }
  }
}
